import React from "react";
import { ContentBlock } from "@/types/case-study";

interface ImageBlockProps {
  block: ContentBlock;
}

export const ImageBlock: React.FC<ImageBlockProps> = ({ block }) => {
  const imageUrl = block.content?.url;
  const caption = block.content?.caption || "";

  return (
    <div className="space-y-3">
      <div className="w-full bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center p-3 md:p-6">
        <img
          src={imageUrl}
          alt={caption || "Case study image"}
          className="w-auto h-auto max-w-full max-h-[450px] rounded-xl object-contain shadow-[0_0_14px_-1px_rgba(15,23,42,0.16)]"
        />
      </div>
      {caption && (
        <p className="text-sm text-gray-600 text-center italic">
          {caption}
        </p>
      )}
    </div>
  );
};